import React from "react";
import { Link } from "react-scroll";
import "../style/hamburger.css";

const Hamburger = (props) => {
  const showHideHamburger = props.toggleHamburger;
  const hamburgerState = props.hamburger;
  return (
    <aside className={hamburgerState ? "hamburger-menu" : "hamburger-menu-hide"}>
      <div className="hamburger-list">
        <li onClick={showHideHamburger} className="list-item-hamburger">
          <i className="fas fa-times"></i>
        </li>
        <Link
          className="vinculo-header"
          to="about"
          smooth={true}
          duration={800}
          onClick={showHideHamburger}
        >
          ABOUT
        </Link>
        <Link
          className="vinculo-header"
          to="portfolio"
          smooth={true}
          duration={800}
          onClick={showHideHamburger}
        >
          PORTFOLIO
        </Link>
        <Link
          className="vinculo-header"
          to="contacto"
          smooth={true}
          duration={800}
          onClick={showHideHamburger}
        >
          CONTACTO
        </Link>
      </div>
    </aside>
  );
};

export default Hamburger;
